import moment from "moment-timezone";
import type { UserPreferences } from "../../../../../../../../../../types/user-preferences";
import type { Option } from "../../types";

export const buildTimeOptions = (
  userPreferences: UserPreferences,
): Option[] => {
  const timeFormat =
    userPreferences.locale.time_format === "24h" ? "HH:mm" : "hh:mm A";
  const date = new Date();
  date.setHours(24, 0, 0, 0);

  let time = moment(date);
  const step = 15;

  const options: Option[] = [];
  while (options.length < 4 * 24) {
    const minutes = time.hours() * 60 + time.minutes();
    options.push({
      label: time.format(timeFormat),
      value: minutes * 60 * 1000,
    });
    time = time.add(step, "minutes");
  }
  return options;
};
